import { IconNameType } from '@servicetitan/anvil-icons';
import { HostApp } from '@servicetitan/marketing-global-route';

import { FeaturesStore } from '../../features/stores/features.store';

export const routeConfiguration = {
    host: HostApp.Standalone,
    rootProject: HostApp.Standalone,
};

// @TODO, when all MFE routes will be in marketing-global-route package, we can clean here and use from there
export enum Routes {
    Home = '/',
    SettingsSection = '/settings',
    AnalyticsSection = '/analytics',
    OneTimeCampaigns = '/analytics/one-time-campaigns',
    AutomatedCampaigns = '/analytics/automated-campaigns',
    CampaignAnalytics = '/analytics/campaign',
    DataExports = '/analytics/data-exports',

    CampaignsSection = '/campaigns',
    CampaignManager = '/campaigns/campaign-manager',
    EmailTemplate = '/campaigns/email-template/templates',
    AutopilotCampaigns = '/campaigns/autopilot',

    AudiencesSection = '/audiences',
    AcquisitionSegments = '/audiences/acquisition-segments',
    RetentionSegments = '/audiences/retention-segments',
    Audiences = '/audiences/audiences',
    Contacts = '/audiences/mcm/contacts',
    Suppression = '/audiences/suppression',
}

export const SAFE_REDIRECT_PATH = '/__redirect';

export const PageTitles = {
    [Routes.Home]: 'Marketing Pro',
    [Routes.SettingsSection]: 'Settings',
    /**
     * Removed in MVP
     * [Routes.SettingsEmailOptInOut]: 'Opt-in / Out',
     * [Routes.SettingsEmailValidation]: 'Email validation',
     */

    [Routes.AnalyticsSection]: 'Analytics',
    [Routes.OneTimeCampaigns]: 'One-Time Campaigns',
    [Routes.CampaignAnalytics]: 'Campaign Analytics',
    [Routes.AutomatedCampaigns]: 'Automated Campaigns',
    [Routes.DataExports]: 'Data Exports',

    [Routes.CampaignsSection]: 'Campaigns',
    [Routes.CampaignManager]: 'Campaign Manager',
    [Routes.EmailTemplate]: 'Email Templates',
    [Routes.AutopilotCampaigns]: 'Autopilot Campaigns',

    [Routes.AudiencesSection]: 'Audiences',
    [Routes.AcquisitionSegments]: 'Acquisition Segments',
    [Routes.RetentionSegments]: 'Retention Segments',
    [Routes.Audiences]: 'Audiences',
    [Routes.Contacts]: 'Contacts',
    [Routes.Suppression]: 'Suppression',
} as const;

export interface AppNavItem {
    title: string;
    key: string;
    iconName?: IconNameType;
    collapsible?: boolean;
    items: AppNavSubItem[];
}

export interface AppNavSubItem {
    title: string;
    path: string;
}

export type AppPageStructureType = AppNavItem[];

export const getAppPageStructure = ({ features }: FeaturesStore): AppPageStructureType => {
    return [
        {
            key: PageTitles[Routes.AnalyticsSection],
            title: PageTitles[Routes.AnalyticsSection],
            iconName: 'assessment',
            collapsible: true,
            items: [
                { title: PageTitles[Routes.OneTimeCampaigns], path: Routes.OneTimeCampaigns },
                { title: PageTitles[Routes.AutomatedCampaigns], path: Routes.AutomatedCampaigns },
                ...(features.isAnalyticsDataExportsEnabled
                    ? [{ title: PageTitles[Routes.DataExports], path: Routes.DataExports }]
                    : []),
            ],
        },
        {
            key: PageTitles[Routes.CampaignsSection],
            title: PageTitles[Routes.CampaignsSection],
            iconName: 'bullhorn',
            collapsible: true,
            items: [
                { title: PageTitles[Routes.CampaignManager], path: Routes.CampaignManager },
                { title: PageTitles[Routes.EmailTemplate], path: Routes.EmailTemplate },
                ...(features.isCampaignManagementAutopilotIntegrationEnabled
                    ? [
                          {
                              title: PageTitles[Routes.AutopilotCampaigns],
                              path: Routes.AutopilotCampaigns,
                          },
                      ]
                    : []),
            ],
        },
        {
            key: PageTitles[Routes.AudiencesSection],
            title: PageTitles[Routes.AudiencesSection],
            iconName: 'people',
            collapsible: true,
            items: [
                {
                    title: PageTitles[Routes.AcquisitionSegments],
                    path: Routes.AcquisitionSegments,
                },
                { title: PageTitles[Routes.RetentionSegments], path: Routes.RetentionSegments },
                { title: PageTitles[Routes.Contacts], path: Routes.Contacts },
                { title: PageTitles[Routes.Suppression], path: Routes.Suppression },
            ],
        },
    ];
};
